import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

/**
 * Extra bottom padding a bottom-anchored view needs in order to clear the Android
 * system navigation bar.
 *
 * Since the Expo SDK 54 hop the Android build is edge-to-edge -- `edgeToEdgeEnabled=true`
 * lands in android/gradle.properties and RN itself reports `isEdgeToEdge: true` -- so the
 * app window spans the WHOLE screen instead of stopping at the top of the system
 * navigation bar. Measured on an API 36 device: window height == screen height == 2400px,
 * with insets `{top: 24, bottom: 48}`. Anything pinned to `bottom: 0` is therefore drawn
 * underneath the navigation bar, where it is both visually clipped and untappable, since
 * the navigation bar takes the touches.
 *
 * Adding this on top of a view's existing bottom padding reproduces the pre-edge-to-edge
 * layout exactly: the padding used to sit above the navigation bar, and now has to make
 * room for it first.
 *
 * Returns 0 on iOS and web. Their layouts were already correct against the home indicator
 * and are deliberately left untouched -- only Android changed.
 */
export const useSystemBottomInset = (): number => {
  const insets = useSafeAreaInsets();

  return Platform.OS === 'android' ? insets.bottom : 0;
};
